export default "__VITE_ASSET__F1W$2VOf__"